module.exports = __webpack_public_path__ + "img/composing-mail.994b6c73.png";